import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import deTranslations from './locales/de.json';
import ruTranslations from './locales/ru.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: {
        translation: deTranslations
      },
      ru: {
        translation: ruTranslations
      }
    },
    fallbackLng: 'de',
    lng: 'de', // Force default to German
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage'], // Only use localStorage, ignore browser settings
      caches: ['localStorage']
    }
  });

export default i18n;